{
  "formStateMachine": {
    "verifying": "Verifying..."
  }
}
